import Carousel from "components/Carousel";
import SellingPoint from "components/SellingPoint";
import React from "react";
import Markdown from "markdown-to-jsx";

const settings = {
  arrows: false,
  autoplaySpeed: 4 * 1e3,
  className: "carousel --fade",
  dots: true,
  dotsClass: "slick-dots carousel__dots --bigger --inverse",
  fade: true,
  infinite: true,
  speed: 500,
  autoplay: true,
};

const carousel = ({ items }) => (
  <Carousel settings={settings}>
    {items.map((item, index) => (
      <SellingPoint
        heading={item.heading}
        key={index}
        alignment={item.alignment}
      >
        <Markdown>{item.content}</Markdown>
      </SellingPoint>
    ))}
  </Carousel>
);

export default carousel;
